import { Box, styled } from "@mui/material";
import React, { useState, useEffect } from "react";
import { ProductListTableOrder } from "./ProductListTableOrder";

const drawerWidth = 200;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open, menuDirection }) => ({
    flexGrow: 1,
    overflowY: "auto",
    padding: theme.spacing(2),
    // transition: theme.transitions.create("margin", {
    //   easing: theme.transitions.easing.sharp,
    //   duration: theme.transitions.duration.leavingScreen,
    // }),
    //   marginLeft: menuDirection == "Left" ? `-${drawerWidth}px` : 0,
    //   ...(open && {
    //     transition: theme.transitions.create("margin", {
    //       easing: theme.transitions.easing.easeOut,
    //       duration: theme.transitions.duration.enteringScreen,
    //     }),
    //     marginLeft: 0,
    //   }),
  })
);

export const TableOrderContent = (props) => {
  const {
    products,
    menuDirection,
    onOpen,
    open,
    selectedProd,
    ApplyTakeOutDeliveryPrice,
    orderType,
  } = props;
  return (
    <Main
      open={open}
      menuDirection={menuDirection}
      sx={{
        width: "55%",
        marginRight: { lg: "25%", xl: "25%" },
      }}
    >
      <ProductListTableOrder
        products={products}
        onOpen={onOpen}
        menuDirection={menuDirection}
        selectedProd={selectedProd}
        ApplyTakeOutDeliveryPrice={ApplyTakeOutDeliveryPrice}
        orderType={orderType}
      />
    </Main>
  );
};
